// extracted by mini-css-extract-plugin
export default {"sidebar-layout":"bjUwP","no-overflow":"wcdej","sidebar":"Z2eR2","empty-sidebar":"G7hr7","content":"wcDnA"};